module.exports = __webpack_public_path__ + "static/next-steps-hero-282046b63fac682a5078d29190459e40.jpg";